export const CommaSeprator = (input) => {
    let value = input;
    let rupee = value?.toString();
    let newRupee = rupee?.substring(rupee.length - 3);
    let other = rupee?.substring(0, rupee.length - 3);
    if (other !== '')
        newRupee = ',' + newRupee;
    //console.log(newRupee);
    let formatedValue = other?.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + newRupee;
    return formatedValue;
}


export const isMobileNotValid = (mobile) => {
    let firstChar = mobile[0];
    for (let i = 0; i < mobile?.length; i++) {
        if (mobile[i] !== firstChar) {
            return false;
        }
    }
    return true;
}

export const getAgeList = (isForYear) => {
    const age = [];
    for (let i = (isForYear ? 0: 0); i <= (isForYear ? 9 : 11); i++) {
        age.push({ value: `${i} ${isForYear ? (i < 2 ? "Year" : "Years") : (i < 2 ? "Month" : "Months")}` });
    }
    return age;
}


export const isObjEmpty = (obj) => {
    if (Object.keys(obj)?.length === 0) {
        return true
    } else return false;

}

export const isBothObjSame = (obj1, obj2) => {
    //check objects is empty or not
    if (!isObjEmpty(obj1) && !isObjEmpty(obj2)) {
        //loop over the key of obj1
        for (let key in obj1) {
            if (!obj2.hasOwnProperty(key)) {
                return false;
            }

            // Check if the values of obj1[key] and obj2[key] are objects
            if (typeof obj1[key] === 'object' && typeof obj2[key] === 'object') {
                 // Recursively compare the nested objects
                if (!isBothObjSame(obj1[key], obj2[key])) {
                    return false; // Nested objects are not equal
                }
            }
                else if (obj1[key] !== obj2[key]) {
                return false;
                }
        }

        return true;
    }
}

export const splitAddress =(fullAddress)=> {
    const addressStr = fullAddress?.split(' ');
    const midpoint = Math.floor(addressStr?.length / 2); // Use Math.floor to get an integer index

    let address1 = '';
    for (let i = 0; i <= midpoint; i++) {
        address1 = address1 +" "+ addressStr[i];
    }
    let address2 = '';
    for (let i = midpoint; i < addressStr?.length; i++) {
        address2 = address2 +" "+ addressStr[i];
    }

    return { address1, address2 };
}

export const validateEmail = (email) => {
    var re = /^(([^<>()\[\]\\.,;#:`~\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

export const validatePan = (pan) => {
    if (pan == null) return false;
    const regex = new RegExp(/^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}$/);
    if (regex.test(pan)) {
        return true;
    } else { return false }

}


export const getMaskForNameWithMaxLength = (maxLength) => {
    // Return an array of `num` elements with the specified pattern
    return Array.from({ length: maxLength }, (_, index) => index === 0 ? /[a-zA-Z]/ : /[a-zA-Z\s]/);
}
